import React from 'react';
const steps = [{
  number: '01',
  title: 'Connect Your Facebook Account',
  description: 'Securely link your Facebook business account to our platform with just a few clicks.'
}, {
  number: '02',
  title: 'Upload Your Ad Content',
  description: 'Upload your ad creatives or use our AI-powered tools to generate new content.'
}, {
  number: '03',
  title: 'Analyze & Optimize',
  description: 'Our AI analyzes your ads and provides optimization recommendations based on performance data.'
}, {
  number: '04',
  title: 'Schedule & Post',
  description: 'Schedule your optimized ads to post at the most effective times for your audience.'
}];
const HowItWorks = () => {
  return <section className="py-20 md:py-32 px-4 md:px-6" data-id="element-94">
      <div className="container mx-auto max-w-6xl" data-id="element-95">
        <div className="text-center mb-16 md:mb-24" data-id="element-96">
          <h2 className="text-3xl md:text-4xl font-light mb-6 tracking-tight" data-id="element-97">
            How It Works
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-98">
            A simple four-step process to revolutionize your Facebook ad
            strategy
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-16" data-id="element-99">
          {steps.map((step, index) => <div key={index} className="border-t border-gray-200 pt-8 md:pt-10" data-id="element-100">
              <span className="text-sm text-gray-400 block mb-4" data-id="element-101">
                {step.number}
              </span>
              <h3 className="text-xl font-medium mb-4 tracking-tight" data-id="element-102">
                {step.title}
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed" data-id="element-103">
                {step.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
};
export default HowItWorks;